import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import PropertyList from '../Property/List';
import NoResults from '../NoResults/NoResults';

const List = ({ properties, filters }) => {
    // Rendered before the early returns: properties are only set on the client (Office
    // componentDidMount), so this is what the server-rendered page gets for title and meta
    const head = (
        <Helmet>
            <title>List of HPP Availabilities | Hudson Pacific Properties</title>
            <meta name="description" property="og:description" content="Our office portfolio features ideally located, custom designed workspaces for innovators and those who support them." />
        </Helmet>
    );

    if (!properties) return head;
    if (properties.length === 0) return <React.Fragment>{head}<NoResults /></React.Fragment>;

    return (
        <div className="section list-view">
            {head}
            <div className="container">
                {properties.filter(property => property.showMarker).map((property, index) => {
                    return (
                        <PropertyList key={index} property={property} filters={filters} />
                    );
                })}
            </div>
        </div>
    );
};

List.propTypes = {
    properties: PropTypes.array,
    filters: PropTypes.object,
};

export default List;
